import { singleRequestServiceFactory } from '../rest/request/singleRequestServiceFactory';
import { placeByIdEndpoint } from 'endpoints';

export const placeByIdRest = {
    placeById: singleRequestServiceFactory(placeByIdEndpoint)
};
